import * as React from "react"

import styled, { css } from "styled-components"

import { convertToValidId } from "libs/utils/dom"

import { UiColor } from "styleguide/styles/colors"
import { UiSize, uiSizeToBaseSize } from "styleguide/styles/sizes"

export interface SvgIconProps {
  size?: UiSize
  color?: UiColor
  title?: string
  viewBoxWidth?: number
  viewBoxHeight?: number
  margin?: "left" | "right"
  id?: string
  onClick?: () => void
}

interface SvgIconTemplateProps {
  size?: UiSize
  color?: UiColor
  viewBoxWidth?: number
  title?: string
  viewBoxHeight?: number
  margin?: "left" | "right"
  children?: React.ReactNode
  id?: string
  onClick?: () => void
}

const StyledSvgIcon = styled.svg`
  max-width: 100%;
  ${(props: SvgIconTemplateProps) => {
    if (props.size) {
      return css`
        width: ${uiSizeToBaseSize(props.size)}px;
        height: ${uiSizeToBaseSize(props.size)}px;
      `
    }
    return css`
      width: ${uiSizeToBaseSize("md")}px;
      height: ${uiSizeToBaseSize("md")}px;
    `
  }}
  ${(props: SvgIconTemplateProps) => {
    if (props.margin) {
      if (props.margin === "left") {
        return css`
          margin-left: 0.6em;
        `
      }
        return css`
          margin-right: 0.6em;
        `

    }
    return css``
  }}
`

const SvgIcon = ({
  children,
  size = "lg",
  title,
  viewBoxWidth = 16,
  viewBoxHeight = 16,
  ...otherProps
}: SvgIconTemplateProps) => {
  const svgId = otherProps.id
    ? convertToValidId(`svg-${title}`, otherProps.id)
    : convertToValidId(
        `svg-${title}`,
        Math.floor(Math.random() * 1000).toString()
      )

  return (
    <StyledSvgIcon
      {...otherProps}
      size={size}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={svgId}
    >
      <title id={svgId}>{title}</title>
      {children}
    </StyledSvgIcon>
  )
}

export default SvgIcon
